<template lang="pug">
.delivery-data-container(@click="expand = !expand")
  .delivery-data
    .delivery-number
      span.material-symbols-outlined(:class="data.brand ? `color-${data.brand}` : ''") local_shipping
      span.tag(:class="data.brand ? `bg-${data.brand}` : ''") {{ data.delivery }}

    .delivery-order(v-if="!history")
      span.material-symbols-outlined(:class="data.brand ? `color-${data.brand}` : ''") {{ data.type === 'exchange' ? 'swap_horiz' : 'shopping_cart' }}
      span.tag(:class="data.brand ? `bg-${data.brand}` : ''") {{ data.type === 'exchange' ? data.change : data.order }}

    .delivery-status(v-if="!history")
      .tag(:style="styleStatus") {{ translateStatus(data.status) }}

    .delivery-name.capitalize(v-if="!history && data.nameRecipient") {{ data.nameRecipient }}

    .delivery-location.capitalize(v-if="!history && data.locationRecipient") {{ data.locationRecipient }}

    .delivery-phone(v-if="!history && data.phonesRecipient && data.phonesRecipient.length") {{ data.phonesRecipient[0] }}

    .delivery-conveyor(v-if="!history && data.conveyor")
      img(:src="`${imagePath}/conveyors/light/mini-${data.conveyor}.png`" :alt="data.conveyor")

    .delivery-delivery-man(v-if="!history && data.nameDeliveryMan") {{ data.nameDeliveryMan }}

    .delivery-days(v-if="!history && data.status !== 'delivered' && data.status !== 'declined'") {{ daysWithoutDelivered(data) }}d

    .delivery-date(v-if="!history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .delivery-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .delivery-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  .delivery-actions-container(@click.stop="")
    .delivery-actions
      .notifications
        img(:class="{disabled: dontSendNotifications}" src="https://sahet-cdn.b-cdn.net/img/others/notifications.svg" alt="notificaciones" @click="dontSendNotifications = !dontSendNotifications")

      .buttons-actions(v-if="data.status === 'created'")
        shActionButton(:action="decline" :params="[data.delivery]" text="Declinar" textRunning="Declinando")
        shActionButton(:action="inProgress" :params="[data.delivery]" text="En Reparto" textRunning="En Reparto")

      .buttons-actions(v-if="data.status === 'inprogress'")
        shActionButton(:action="cancelDeliveryInProgress" :params="[data.delivery]" text="Cancelar Reparto" textRunning="Cancelando")
        shActionButton(:action="openDeliveredModal" :params="[data.delivery]" text="Entregar" textRunning="Entregando")

      .buttons-actions(v-if="data.status === 'delivered'")
        shActionButton(:action="cancelDelivered" :params="[data.delivery]" text="Cancelar Entrega" textRunning="Cancelando")

  // .delivery-subcontainer(@click.stop="")
    .delivery-charge(v-if="!data.replacementCharge")
      span Recoger: {{ money(data.charge) }}
      span.color-green.dark(v-if="data.collectedBy") · Cobrado
      shActionButton(v-if="!data.collectedBy" :action="collectCharge" :params="[data.delivery]" text="Recoger Cobro" textRunning="Recogiendo" :mini="true")
      shActionButton(v-else :action="cancelCollectCharge" :params="[data.delivery]" text="Cancelar Cobro" textRunning="Cancelando" :mini="true")

    .delivery-charge(v-if="data.replacementCharge")
      span Recoger: {{ money(data.replacementCharge) }}
      span.color-green.dark(v-if="data.collectedBy") · Cobrado
      shActionButton(v-if="!data.collectedBy" :action="collectCharge" :params="[data.delivery]" text="Recoger Cobro" textRunning="Recogiendo" :mini="true")
      shActionButton(v-else :action="cancelCollectCharge" :params="[data.delivery]" text="Cancelar Cobro" textRunning="Cancelando" :mini="true")

    .delivery-charge
      span Envío: {{ money(data.cost || 0) }}
      span.color-green.dark(v-if="data.paidBy") · Pagado
      shActionButton(v-if="!data.paidBy" :action="payDelivery" :params="[data.delivery]" text="Pagar Envío" textRunning="Pagando" :mini="true")
      shActionButton(v-else :action="cancelPayDelivery" :params="[data.delivery]" text="Eliminar Pago" textRunning="Eliminando" :mini="true")

  transition(name="slide-fade")
    shForm.list-delivery(v-if="expand && !history" :dataOriginal="data" :fillData="true" :sendNotifications="!dontSendNotifications" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-delivery(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")

  transition(name="slide-fade")
    .delivery-delivered-modal.center(v-if="showDeliveredConfirm" @click.self="closeDeliveredModal")
      .delivery-delivered-dialog(@click.stop="")
        h3 Confirmación
        .delivery-delivered-text Se registrará como entregada con la fecha indicada abajo. ¿Deseas continuar?
        .delivery-delivered-datetime
          label.delivery-delivered-label Fecha y hora de entrega
          input.delivery-delivered-input(v-model="deliveredAtLocal" type="datetime-local")
        .delivery-delivered-buttons
          shActionButton(:action="closeDeliveredModal" text="No" textRunning="No")
          shActionButton(:action="confirmMarkDelivered" text="Sí" textRunning="Sí" :principalColor="true")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import { daysWithoutDelivered } from '@/helpers/deliveryDays'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import gqlDelivery from '@/graphql/delivery'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'Delivery',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      dontSendNotifications: false,
      leftBuildingReception: false,
      showDeliveredConfirm: false,
      pendingDeliverDelivery: '',
      deliveredAtLocal: '',
      markDeliveredRunning: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    daysWithoutDelivered,

    async decline (delivery) {
      const mutation = gqlDelivery.DECLINE
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `La entrega ${delivery} se declinó` })
    },

    async inProgress (delivery) {
      const mutation = gqlDelivery.IN_PROGRESS
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery, sendNotifications: !this.dontSendNotifications })
      if (response) modals.showMessage({ message: `La entrega ${delivery} se encuentra en reparto` })
    },

    async cancelDeliveryInProgress (delivery) {
      const mutation = gqlDelivery.CANCEL_DELIVERY_IN_PROCESS
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `Se canceló el reparto de la entrega ${delivery}` })
    },

    formatNowForDatetimeLocal () {
      const d = new Date()
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    },

    openDeliveredModal (delivery) {
      if (!delivery) return
      this.pendingDeliverDelivery = delivery
      this.deliveredAtLocal = this.formatNowForDatetimeLocal()
      this.showDeliveredConfirm = true
    },

    closeDeliveredModal () {
      this.showDeliveredConfirm = false
      this.pendingDeliverDelivery = ''
    },

    async confirmMarkDelivered () {
      if (this.markDeliveredRunning) return
      const delivery = this.pendingDeliverDelivery
      if (!delivery) return
      if (!this.deliveredAtLocal) {
        modals.showMessage({ message: 'Indica la fecha y hora de entrega.', type: 'error' })
        return
      }
      const parsed = new Date(this.deliveredAtLocal)
      if (isNaN(parsed.getTime())) {
        modals.showMessage({ message: 'La fecha de entrega no es válida.', type: 'error' })
        return
      }

      this.markDeliveredRunning = true
      try {
        const mutation = gqlDelivery.DELIVERED
        const variables = {
          delivery,
          leftBuildingReception: this.leftBuildingReception,
          sendNotifications: !this.dontSendNotifications,
          deliveredAt: parsed.toISOString()
        }
        const response = await gql.mutate(mutation, variables)
        if (response) {
          this.closeDeliveredModal()
          modals.showMessage({ message: `La entrega ${delivery} fue recibida exitosamente` })
        }
      } finally {
        this.markDeliveredRunning = false
      }
    },

    async cancelDelivered (delivery) {
      const mutation = gqlDelivery.CANCEL_DELIVERED
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `La entrega ${delivery} ha sido cancelada` })
    },

    async payDelivery (delivery) {
      const mutation = gqlDelivery.PAY_DELIVERY
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `La entrega ${delivery} ha sido pagada` })
    },

    async collectCharge (delivery) {
      const mutation = gqlDelivery.COLLECT_CHARGE
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `La entrega ${delivery} ha sido cobrada` })
    },

    async cancelPayDelivery (delivery) {
      const mutation = gqlDelivery.CANCEL_PAY_DELIVERY
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `Se canceló el pago de la entrega ${delivery}` })
    },

    async cancelCollectCharge (delivery) {
      const mutation = gqlDelivery.CANCEL_COLLECT_CHARGE
      if (!delivery) return
      const response = await gql.mutate(mutation, { delivery })
      if (response) modals.showMessage({ message: `Se canceló el cobro de la entrega ${delivery}` })
    },

    translateStatus (status) {
      const map = {
        created: 'Creado',
        inprogress: 'En Reparto',
        delivered: 'Entregado',
        declined: 'Declinado'
      }
      return map[status] || status
    }
  },

  computed: {
    styleStatus () {
      const colors = {
        created: { background: '#e9e9e7', color: '#616161' },
        inprogress: { background: '#F1FF57', color: '#616161' },
        delivered: { background: '#A5AA72', color: '#ffffff' },
        declined: { background: '#AA7572', color: '#ffffff' }
      }
      const c = colors[this.data.status]
      if (!c) return ''
      return `background: ${c.background}; color: ${c.color}`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

actions-width = 20rem

.delivery-delivered-modal
  position fixed
  width 100%
  height 100%
  left 0
  top 0
  background-color rgba(0, 0, 0, .4)
  z-index 200
  display flex
  justify-content center
  align-items center

.delivery-delivered-dialog
  background-color var(--background-principal)
  padding 2em 3em
  borderRadius(.5em)
  width 100%
  max-width 40em

.delivery-delivered-dialog h3
  margin 0 0 0.5em 0

.delivery-delivered-text
  margin .5em 0 1em 0
  font-size 1.1em

.delivery-delivered-datetime
  margin 1em 0 1.25em 0
  display flex
  flex-direction column
  gap 0.5em

.delivery-delivered-label
  font-size 0.95em
  color rgba(0, 0, 0, 0.65)

.delivery-delivered-input
  width 100%
  max-width 22em
  padding 0.65em 0.85em
  font-size 1rem
  border 1px solid rgb(200, 200, 200)
  border-radius 0.35em
  background var(--background-principal)

.delivery-delivered-buttons
  display flex
  justify-content center
  align-items center
  gap 1em

.delivery-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.delivery-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.delivery-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem
  flex-shrink 0
  flex-basis actions-width

.delivery-actions
  display flex
  align-items center
  gap 1em

.delivery-actions .notifications img
  height 1.3em
  cursor pointer

.delivery-actions .notifications img.disabled
  opacity .2

.delivery-number, .delivery-order
  display flex
  align-items center
  gap .5em

.delivery-conveyor
  display flex
  justify-content center

.delivery-conveyor img
  height 1.4em
  display block

.delivery-days
  color red
  font-size .9em

.delivery-subcontainer
  flex-basis 100%
  display flex
  flex-wrap wrap
  gap 1em
  padding 0 1rem
  opacity .5

.delivery-subcontainer:hover
  opacity 1

.delivery-charge
  display inline-flex
  align-items center
  gap .6em
  font-size 1.1rem

.list-delivery
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .delivery-data
    flex-basis unquote('calc(100% - ' + actions-width + ' - 5rem)')
    column-gap 0
    row-gap 1em

  .delivery-number
    width 7em
  .delivery-order
    width 8em
  .delivery-status
    width 8em
  .delivery-name
    width 8em
  .delivery-location
    width 8em
  .delivery-phone
    width 8em
  .delivery-conveyor
    width 5em
  .delivery-delivery-man
    width 8em
  .delivery-days
    width 4em
  .delivery-date
    width 10em
  .delivery-transaction
    width 8em
  .delivery-actions
    width 16em

  .delivery-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/delivery/Delivery.vue